import { create } from 'zustand'

interface ContasState {
  pagar: number
  orcamentos: number
  receber: number
  vendas: number
  compras: number
  produtos: number
  setReceber: (value: number) => void
  setPagar: (value: number) => void
  setVendas: (value: number) => void
  setOrcamentos: (value: number) => void
  setProdutos: (value: number) => void
  setCompras: (value: number) => void
}

export const useContasStore = create<ContasState>(set => ({
  pagar: 0,
  receber: 0,
  orcamentos: 0,
  produtos: 0,
  vendas: 0,
  compras: 0,
  setProdutos: value => set({ produtos: value }),
  setReceber: value => set({ receber: value }),
  setOrcamentos: value => set({ orcamentos: value }),
  setPagar: value => set({ pagar: value }),
  setVendas: value => set({ vendas: value }),
  setCompras: value => set({ compras: value }),
}))
